(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('product:variant-change', function () {
    document.querySelectorAll('[data-product-form][data-sale-window]').forEach(function (form) {
      var state = form.getAttribute('data-sale-window');
      if (state !== 'upcoming' && state !== 'ended') return;
      var label = form.getAttribute('data-sale-window-label') || '';
      form.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        var text = btn.querySelector('[data-add-to-cart-text]');
        if (text && label) text.textContent = label;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sale-window-lock"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__saleWindowLock) return;
    window.__saleWindowLock = true;

    var closedStates = { upcoming: true, ended: true };

    function isClosed(state) {
      return Boolean(closedStates[state]);
    }

    function lockProductForms() {
      document.querySelectorAll('[data-product-form][data-sale-window]').forEach(function (form) {
        var state = form.getAttribute('data-sale-window');
        if (!isClosed(state)) return;

        var label = form.getAttribute('data-sale-window-label') || '';
        form.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-disabled', 'true');
          var text = btn.querySelector('[data-add-to-cart-text]');
          if (text && label) text.textContent = label;
        });
      });
    }

    function cartHasClosedSaleWindow() {
      return Boolean(
        document.querySelector(
          '[data-input-item][data-sale-window="upcoming"], [data-input-item][data-sale-window="ended"]'
        )
      );
    }

    function lockCartCheckout() {
      var blocked = cartHasClosedSaleWindow();
      document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
        if (blocked) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
        }
      });
      document.querySelectorAll('[data-additional-checkout-buttons]').forEach(function (el) {
        el.hidden = blocked;
      });
    }

    function applyLocks() {
      lockProductForms();
      lockCartCheckout();
    }

    document.addEventListener('product:variant-change', applyLocks);
    document.addEventListener('cart:updated', function () {
      requestAnimationFrame(applyLocks);
      setTimeout(applyLocks, 400);
    });
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        var saleWindow = form.getAttribute('data-sale-window');
        if (isClosed(saleWindow)) {
          event.preventDefault();
          return;
        }

        var submitter = event.submitter;
        if (submitter && submitter.getAttribute('name') === 'checkout' && cartHasClosedSaleWindow()) {
          event.preventDefault();
        }
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyLocks);
    } else {
      applyLocks();
    }

    var root = document.body;
    if (root && typeof MutationObserver === 'function') {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          applyLocks();
        });
      });
      observer.observe(root, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
